import { Navigate, Outlet } from "react-router-dom";
import { useIsLawyer } from "@/shared/hooks/useIsLawyer";
import { LAWYER_ROUTES } from "@/shared/constants/paths";

/**
 * Wrapper for public routes that can be accessed without authentication.
 * Redirects logged-in lawyers to their dashboard (uses cached status to avoid spinners).
 */
export function PublicRouteWrapper() {
  const { isLawyer } = useIsLawyer();

  if (isLawyer) {
    return <Navigate to={LAWYER_ROUTES.DASHBOARD} replace />;
  }

  return <Outlet />;
}
